// Let's move all type conversions all in this file, so we at least can test it

import { Editor } from "draft-js";
export * from "chalet-shared/dist/utils/any";

export const assign = <Target, Source>(target: Target, source: Source) => {
    if (source !== undefined) {
        return source;
    } else {
        return target;
    }
};

export function addGlobalDebug(key: string, value: any) {
    (window as any)[key] = value;
}

export function draftRefs(comp: Editor) {
    // undocumented private refs of Draft JS
    const { editor, editorContainer } = (comp as any) as {
        editor: HTMLDivElement;
        editorContainer: HTMLDivElement;
    };
    return { editor, editorContainer };
}

const empty: never[] = [];
export function sameEmptyArray<T>(arr: T[]) {
    return arr.length ? arr : empty;
}
